import React, { useEffect } from "react";
import { motion } from "framer-motion"; // Import motion
import "../styles/Service.css"; // Optional CSS for styling
import agric from "../assets/agriculture.jpeg";
import mapping from "../assets/mapping.jpeg";
import inspection from "../assets/Inspection.jpg";
import mining from "../assets/mining.jpeg";
import aerial from "../assets/aerial.jpeg";
import marketing from "../assets/marketing.jpg";
import data from "../assets/data.jpeg";
import surv from "../assets/surv.png";
import edu from "../assets/education.jpeg"
import mentor from "../assets/mentor.jpeg"

const ServiceItem = ({ title, description, applications, benefits, image }) => (
  <motion.div
    className="service-item"
    initial={{ opacity: 0, y: 20 }} // Initial state
    animate={{ opacity: 1, y: 0 }} // Animate to these values
    transition={{ duration: 0.5 }} // Transition duration
  >
    <div className="service-image">
      <img src={image} alt={title} />
    </div>
    <div className="service-content">
      <h2>{title}</h2>
      <p>{description}</p>
      <h4>Applications:</h4>
      <ul>
        {applications.map((app, index) => (
          <li key={index}>{app}</li>
        ))}
      </ul>
      <h4>Benefits:</h4>
      <ul>
        {benefits.map((benefit, index) => (
          <li key={index}>{benefit}</li>
        ))}
      </ul>
    </div>
  </motion.div>
);

const ServicesPage = () => {
  const services = [
    {
      title: "Mapping & Surveying",
      description:
        "Our high-precision aerial mapping and topographical surveys provide invaluable data for construction, agriculture, and land development.",
      applications: [
        "Construction site surveys",
        "Land use planning",
        "Infrastructure development",
      ],
      benefits: ["Faster data collection", "Enhanced accuracy", "Cost savings"],
      image: mapping,
    },
    {
      title: "Inspections",
      description:
        "We offer comprehensive inspections for infrastructure, equipment, and industrial facilities, reducing the need for manual inspections in hazardous environments.",
      applications: [
        "Power line inspections",
        "Roof assessments",
        "Bridge and tower evaluations",
      ],
      benefits: [
        "Increased safety",
        "Detailed analysis",
        "Real-time monitoring",
      ],
      image: inspection,
    },
    {
      title: "Agricultural Solutions",
      description:
        "Our drone services revolutionize farming practices by providing aerial crop monitoring, health assessments, and precision farming solutions.",
      applications: [
        "Crop scouting",
        "Irrigation planning",
        "Soil health monitoring",
      ],
      benefits: [
        "Improved crop management",
        "Precise data collection",
        "Optimized resources",
      ],
      image: agric,
    },
    {
      title: "Aerial Photography & Videography",
      description:
        "Capture breathtaking visuals from above with our professional drone photography and videography services. Perfect for real estate, marketing campaigns, and special events.",
      applications: [
        "Real estate listings",
        "Promotional videos",
        "Event coverage",
      ],
      benefits: [
        "Stunning high-resolution imagery",
        "Unique perspectives",
        "Enhanced marketing",
      ],
      image: aerial,
    },
    {
      title: "Advertising & Marketing Campaigns",
      description:
        "Enhance your brand visibility with dynamic aerial advertising. Our drones can create visually striking content that engages your audience in a whole new way.",
      applications: [
        "Brand campaigns",
        "Social media content",
        "Event promotions",
      ],
      benefits: ["Unique brand exposure", "Memorable campaigns", "Wide reach"],
      image: marketing,
    },
    {
      title: "Research & Data Collection",
      description:
        "Our drones gather critical data from difficult-to-reach areas with precision and reliability, ensuring valuable insights for academic or commercial projects.",
      applications: [
        "Environmental research",
        "Disaster management",
        "Urban planning",
      ],
      benefits: [
        "Access to remote locations",
        "Timely data collection",
        "Informed decision-making",
      ],
      image: data,
    },
    {
      title: "Mining Operations",
      description:
        "We support the mining industry with detailed aerial surveys, resource mapping, and safety inspections, ensuring compliance and operational efficiency.",
      applications: [
        "Site mapping",
        "Monitoring extraction processes",
        "Safety evaluations",
      ],
      benefits: [
        "Improved safety",
        "Real-time insights",
        "Reduced operational downtime",
      ],
      image: mining,
    },
    {
      title: "Monitoring & Surveillance",
      description:
        "Our drones offer real-time monitoring and surveillance solutions for various industries, providing continuous oversight for safety, security, and management purposes.",
      applications: [
        "Security surveillance",
        "Wildlife monitoring",
        "Disaster response",
      ],
      benefits: ["Live updates", "Wide-area coverage", "Risk reduction"],
      image: surv,
    },
    {
      title: "Mathematics and English Mentoring for Aspiring Remote Pilots",
      description:
        "This program provides targeted mentoring in mathematics and English for students aspiring to become remote pilots. The focus is on essential skills in mathematical reasoning, communication, and aviation terminology to prepare them for successful careers in the drone industry.",
      applications: [
        "Enhance mathematical skills relevant to aviation",
        "Improve English proficiency for effective communication",
        "Introduce industry-specific language and concepts",
      ],
      benefits: [
        "Strengthened foundation in mathematics and language",
        "Increased career readiness",
        "Support for professional remote pilot certification",
      ],
      image: mentor,
    }
    ,
    {
      title: "Drone Technology Awareness Campaign in Disadvantaged Schools",
      description:
        "Our initiative aims to introduce drone technology to students in disadvantaged schools, inspiring interest in STEM fields and providing hands-on learning experiences with drones to broaden future career opportunities.",
      applications: [
        "Increase awareness of drone technology",
        "Encourage interest in STEM careers",
        "Provide hands-on learning opportunities",
      ],
      benefits: [
        "Hands-on experience with technology",
        "STEM education support",
        "Opportunities for career exploration",
      ],
      image: edu,
    }
    
  ];

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when this component mounts
  }, []);

  return (
    <div className="service-container">
      <div className="services-page">
        <h1>Our Services</h1>
        <p>
          At <strong>GiftEng Aerial Solutions</strong>, we specialize in a broad
          range of drone services designed to meet the unique needs of our
          clients across various industries. Explore our services below:
        </p>
        {services.map((service, index) => (
          <ServiceItem
            key={index}
            title={service.title}
            description={service.description}
            applications={service.applications}
            benefits={service.benefits}
            image={service.image}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicesPage;
